<template>
  <div>
    <div class="d-block d-lg-none mb-2">
      <v-dropdown-menu
        :text="selectedTabText"
        :translate-text="false"
        style-type="link"
        :block="true"
        alignment="left"
      >
        <template v-slot:menu>
          <v-dropdown-menu-button
            text="word.dashboard"
            icon="chart-bar"
            :selected="selectedTab === 'dashboard'"
            @click="selectTab('dashboard')"
          />
          <v-dropdown-menu-button
            text="phrase.data_per_question"
            icon="list-1-2"
            :selected="selectedTab === 'items'"
            @click="selectTab('items')"
          />
          <v-dropdown-menu-button
            text="phrase.all_answers"
            icon="table"
            :selected="selectedTab === 'table'"
            @click="selectTab('table')"
          />
          <v-dropdown-menu-button
            text="word.overview"
            icon="list"
            :selected="selectedTab === 'general'"
            @click="selectTab('general')"
          />
        </template>
      </v-dropdown-menu>
    </div>
    <ul class="nav nav-tabs nav-justified d-none d-lg-flex mb-2">
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{active: selectedTab === 'dashboard'}"
          href="javascript:void(0)"
          @click="() => {selectTab('dashboard')}"
        >
          <div class="w-100 d-flex justify-content-center">
            <div class="mr-2">
              <i class="fa fa-chart-bar"></i>
            </div>
            {{ $t('word.dashboard') }}
          </div>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{active: selectedTab === 'items'}"
          href="javascript:void(0)"
          @click="() => {selectTab('items')}"
        >
          <div class="w-100 d-flex justify-content-center">
            <div class="mr-2">
              <i class="fa fa-list-1-2"></i>
            </div>
            {{ $t('phrase.data_per_question') }}
          </div>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{active: selectedTab === 'table'}"
          href="javascript:void(0)"
          @click="() => {selectTab('table')}"
        >
          <div class="w-100 d-flex justify-content-center">
            <div class="mr-2">
              <i class="fa fa-table mr-2"></i>
            </div>
            {{ $t('phrase.all_answers') }}
          </div>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{active: selectedTab === 'general'}"
          href="javascript:void(0)"
          @click="() => {selectTab('general')}"
        >
          <div class="w-100 d-flex justify-content-center">
            <div class="mr-2">
              <i class="fa fa-list mr-2"></i>
            </div>
            {{ $t('word.overview') }}
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import DropdownMenu from '@/common/components/DropdownMenu.vue';
import DropdownMenuButton from '@/common/components/DropdownMenuButton.vue';

const TAB_TEXTS = {
  dashboard: 'word.dashboard',
  items: 'phrase.data_per_question',
  table: 'phrase.all_answers',
  general: 'word.overview',
};

export default {
  name: 'DashboardTabs',
  components: {
    'v-dropdown-menu': DropdownMenu,
    'v-dropdown-menu-button': DropdownMenuButton,
  },
  data() {
    return {
      selectedTab: 'dashboard',
    };
  },
  computed: {
    selectedTabText() {
      return this.$t(TAB_TEXTS[this.selectedTab]);
    },
  },
  methods: {
    selectTab(tab) {
      this.$router.push({ query: { ...this.$route.query, tab } });
    },
  },
  created() {
    if (this.$route.query.tab) {
      this.selectedTab = this.$route.query.tab;
    }
  },
};
</script>
